import { Suspense } from 'react';

import type { XingletLoaderProps } from '@xing-com/crate-xinglet';
import { InternalXingletLoader } from '@xing-com/crate-xinglet/internal';

import { XingletErrorBoundary } from './xinglet-error-boundary';

export const XingletLoader: React.FC<XingletLoaderProps> = ({
  error: errorFallback,
  fallback,
  name,
  ...rest
}) => {
  return (
    <XingletErrorBoundary fallback={errorFallback} xinglet={name}>
      <Suspense fallback={fallback}>
        <InternalXingletLoader {...rest} fallback={fallback} name={name} />
      </Suspense>
    </XingletErrorBoundary>
  );
};
